import { Application } from "pixi.js"

import mouse from "../../input/mouse"
import PositionObject from "../modules/PositionObject"
import Vector from "../Vector"
import World from "./World"

export default class PhysicsWorld extends World<Application> {

	friction = 0.2

	bindCanvas(pixi: Application) {
		super.bindCanvas(pixi)

		if (pixi) {

			pixi.renderer.plugins.viewport.on('pointermove', (event: any) => {
				const pos = pixi.renderer.plugins.viewport.toWorld(event.data.global)
				mouse.position.x = pos.x
				mouse.position.y = pos.y
			})

			pixi.ticker.add(delta => {
				this.tick(delta * (1 / 60))
			})
		}
	}

	findInRadius(x: number, y: number, radius: number) {
		const position = new Vector(x, y)

		return this.getItems().filter(ent => {
			if (ent instanceof PositionObject) {
				const length = position.clone().subtract(ent.position).length()

				return (length <= radius)
			}
			return false
		})
	}

}